module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Cadastro de Arrematante")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.data.id) ? _c('router-link', {
    staticClass: "pull-right hidden-print",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'arrematante.visualizar',
        params: {
          id: _vm.data.id
        }
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Atualizado com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.tipo),
      expression: "data.pessoa.tipo"
    }],
    attrs: {
      "type": "radio",
      "id": "tipoPessoaFisica"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.data.pessoa.tipo, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.data.pessoa, "tipo", 1)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tipoPessoaFisica"
    }
  }, [_vm._v("Física")]), _vm._v("  \n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.tipo),
      expression: "data.pessoa.tipo"
    }],
    attrs: {
      "type": "radio",
      "id": "tipoPessoaJuridica"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.data.pessoa.tipo, 2)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.data.pessoa, "tipo", 2)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tipoPessoaJuridica"
    }
  }, [_vm._v("Jurídica")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.nome),
      expression: "data.pessoa.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Apelido")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.apelido),
      expression: "data.apelido"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.apelido)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "apelido", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.data.pessoa.tipo === 1) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pfCpf),
      expression: "data.pessoa.pfCpf"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pfCpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pfCpf", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Nascimento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pfDataNascimento),
      expression: "data.pessoa.pfDataNascimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pfDataNascimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pfDataNascimento", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("RG")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pfRg),
      expression: "data.pessoa.pfRg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pfRg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pfRg", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Emissor:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pfRgOrgaoEmissor),
      expression: "data.pessoa.pfRgOrgaoEmissor"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pfRgOrgaoEmissor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pfRgOrgaoEmissor", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Expedição:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pfRgDataExpedicao),
      expression: "data.pessoa.pfRgDataExpedicao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pfRgDataExpedicao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pfRgDataExpedicao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Nacionalidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.nacionalidade),
      expression: "data.pessoa.nacionalidade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data.pessoa, "nacionalidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Brasileira")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Extrangeira")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Estado Civil:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pfEstadoCivil),
      expression: "data.pessoa.pfEstadoCivil"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data.pessoa, "pfEstadoCivil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.getStatus.EstadoCivil), function(ec, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(ec))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Sexo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pfSexo),
      expression: "data.pessoa.pfSexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data.pessoa, "pfSexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Feminino")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('strong', [_vm._v("Dados do Cônjuge")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Nome do Cônjuge")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.conjugeNome),
      expression: "data.conjugeNome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.conjugeNome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "conjugeNome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.conjugeCpf),
      expression: "data.conjugeCpf"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.conjugeCpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "conjugeCpf", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("RG:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.conjugeRg),
      expression: "data.conjugeRg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.conjugeRg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "conjugeRg", $event.target.value)
      }
    }
  })])])])])])])]) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pjCnpj),
      expression: "data.pessoa.pjCnpj"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pjCnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pjCnpj", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Inscrição Estadual")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pjInscricaoEstadual),
      expression: "data.pessoa.pjInscricaoEstadual"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pjInscricaoEstadual)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pjInscricaoEstadual", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pjNomeFantasia),
      expression: "data.pessoa.pjNomeFantasia"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pjNomeFantasia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pjNomeFantasia", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Razão Social")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.pjRazaoSocial),
      expression: "data.pessoa.pjRazaoSocial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.pjRazaoSocial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa, "pjRazaoSocial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Responsável")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pjProprietarioNome),
      expression: "data.pjProprietarioNome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pjProprietarioNome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "pjProprietarioNome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pjProprietarioCpf),
      expression: "data.pjProprietarioCpf"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pjProprietarioCpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "pjProprietarioCpf", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("RG")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pjProprietarioRg),
      expression: "data.pjProprietarioRg"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pjProprietarioRg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "pjProprietarioRg", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('strong', [_vm._v("Informações de Endereço")])])]), _vm._v(" "), _vm._l((_vm.data.pessoa.enderecos), function(endereco) {
    return _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (endereco.cep),
        expression: "endereco.cep"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('#####-###'),
        expression: "'#####-###'"
      }],
      class: ("form-control " + (_vm.isCepInvalid ? 'border-red': null)),
      attrs: {
        "type": "text",
        "placeholer": "00000-000"
      },
      domProps: {
        "value": (endereco.cep)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(endereco, "cep", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.isCepInvalid) ? _c('small', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Cep inválido")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (endereco.logradouro),
        expression: "endereco.logradouro"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (endereco.logradouro)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(endereco, "logradouro", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label"
    }, [_vm._v("Número:")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (endereco.numero),
        expression: "endereco.numero"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (endereco.numero)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(endereco, "numero", $event.target.value)
        }
      }
    })])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("Bairro")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (endereco.bairro),
        expression: "endereco.bairro"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (endereco.bairro)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(endereco, "bairro", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-3 control-label"
    }, [_vm._v("Complemento:")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (endereco.complemento),
        expression: "endereco.complemento"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (endereco.complemento)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(endereco, "complemento", $event.target.value)
        }
      }
    })])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (endereco.ufOutros),
        expression: "endereco.ufOutros"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (endereco.ufOutros)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(endereco, "ufOutros", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("Cidade:")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (endereco.cidadeOutros),
        expression: "endereco.cidadeOutros"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (endereco.cidadeOutros)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(endereco, "cidadeOutros", $event.target.value)
        }
      }
    })])])])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('strong', [_vm._v("Informações de Contato")])])]), _vm._v(" "), (_vm.data.pessoa.emails && _vm.data.pessoa.emails.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.pessoa.emails[0].email),
      expression: "data.pessoa.emails[0].email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.pessoa.emails[0].email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.pessoa.emails[0], "email", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data.pessoa.telefones), function(telefone, key) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("Telefone " + _vm._s(key + 1))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (telefone.telefone),
        expression: "telefone.telefone"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (telefone.telefone)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(telefone, "telefone", $event.target.value)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group m-t-n"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('a', {
    staticClass: "btn btn-xs m-t-xs",
    on: {
      "click": function($event) {
        return _vm.data.pessoa.telefones.push({
          telefone: ''
        })
      }
    }
  }, [_vm._v("Adicionar\n                  telefone")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('strong', [_vm._v("Informações Adicionais")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Observações Internas")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.observacao),
      expression: "data.observacao"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.data.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "observacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.data.pessoa.tipo === 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Pode Comprar Sucata")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('label', {
    staticClass: "i-switch bg-success m-t-xs m-r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.podeComprarSucata),
      expression: "data.podeComprarSucata"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.podeComprarSucata) ? _vm._i(_vm.data.podeComprarSucata, null) > -1 : (_vm.data.podeComprarSucata)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.podeComprarSucata,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "podeComprarSucata", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "podeComprarSucata", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "podeComprarSucata", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    on: {
      "click": _vm.submit
    }
  }, [(!_vm.data.id) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default"
  }, [_vm._v("Cancelar")]), _vm._v(" "), (!_vm.data.id) ? _c('span', [_vm._v("Ao cadastrar, o status do lote será "), _c('span', {
    staticClass: "text-info"
  }, [_vm._v("Rascunho")]), _vm._v(", para publicá-lo, altere o status após o cadastro.")]) : _vm._e()], 1)], 2)])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e10c005a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/Arrematante.vue
// module id = 2073
// module chunks = 18